module.exports = __webpack_public_path__ + "static/media/vertical_loading_rate.25ca6070.png";